import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal} from 'antd'
import {QuestionCircleFilled, EditOutlined, DeleteOutlined} from '@ant-design/icons'
import FormModal from './FormModal'
import {withTranslation} from 'react-i18next'

const {confirm} = Modal

@inject('reportTagStore')
@observer
class SearchResult extends Component {
  state = {
    addModalVisible: false,
  }

  handleEdit = (record) => {
    this.setState({
      addModalVisible: true,
      record,
    })
  }

  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  handleDel = (record) => {
    const {reportTagStore, t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportTagStore.deleteReportTag(record?.id)
      },
      onCancel() {
        console.log('Cancel');
      },
    })
    return false
  }

  handlePageChange = (page, pageSize) => {
    const {reportTagStore} = this.props
    reportTagStore.onChangePageNumAction(page, pageSize);
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const {reportTagStore, t} = this.props
    const {pageNo, pageSize, itemCount, tagList} = reportTagStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(tagList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName}>
          <Table.Column title={t(`reportTag.tagName`)} dataIndex="tagName" key="tagName" ellipsis={true}/>
          <Table.Column title={t(`reportTag.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
          title="edit"
          record={this.state.record}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)